// extracted by mini-css-extract-plugin
export default {"howitworks":"HowItWorks_howitworks__s0Slv","howitworks__title":"HowItWorks_howitworks__title__-3-b2","howitworks__text":"HowItWorks_howitworks__text__HWVnz"};